import { createContext, useContext } from 'react';

interface IGoogleMapContextData {
    map: google.maps.Map;
}

const GoogleMapContext = createContext<IGoogleMapContextData>(null);

export const useGoogleMapContext = () => {
    const context = useContext(GoogleMapContext);

    if (context == null) {
        throw new Error('GoogleMapContext must be used within <GoogleMap />');
    }

    return context;
};

export default GoogleMapContext;
